<template>
  <div :class="b()" :style="styleSizeName">
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <avue-echart-empty />
    </template>
  </div>
</template>

<script>
import { formatByPath } from '@/utils/category';
import init from '@/mixins/chart';
export default {
  name: 'ari-bubble',
  mixins: [init],
  computed: {
    x2() {
      return this.option.gridX2 || 90;
    },
    hasData() {
      return this.dataChart?.series?.length > 0;
    }
  },

  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      const option = {
        title: this.ishasprop(
          this.option.titleShow,
          {
            text: this.option.title,
            subtext: this.option.subtext || '',
            textStyle: {
              color: this.option.titleColor || '#333',
              fontSize: this.option.titleFontSize || 16
            },
            left: this.option.titlePostion || 'auto',
            subtextStyle: {
              color: this.option.subTitleColor || '#aaa',
              fontSize: this.option.subTitleFontSize || 14
            }
          },
          {}
        ),
        tooltip: this.ishasprop(
          this.formatter,
          {
            formatter: name => {
              return this.formatter(name, this.dataChart);
            }
          },
          {
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor || '#fff'
            },
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: params => {
              let result = params[0]?.axisValueLabel;
              for (const param of params) {
                // y2格式化
                let value = param.value;
                const {
                  yAxisShow,
                  yValueFormatPath = [],
                  yAxisSecondShow,
                  yValueSecondFormatPath = []
                } = this.option;
                if (param.seriesIndex === 1) {
                  if (yAxisSecondShow) {
                    if (yValueSecondFormatPath.length > 0) {
                      value = formatByPath(yValueSecondFormatPath, value);
                    }
                  } else {
                    if (yAxisShow && yValueFormatPath.length > 0) {
                      value = formatByPath(yValueFormatPath, value);
                    }
                  }
                  result += `<br/>${param.marker}${param.seriesName}: ${value}`;
                } else {
                  if (yAxisShow && yValueFormatPath.length > 0) {
                    value = formatByPath(yValueFormatPath, value);
                  }
                  result += `<br/>${param.marker}${param.seriesName}: ${value}`;
                }
              }
              return result;
            }
          }
        ),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || 'vertical',
          x: this.option.legendPostion || 'left',
          bottom: 0,
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: (() => {
            return (optionData.series || []).map((ele, index) => {
              return {
                name: ele.name,
                textStyle: this.ishasprop(
                  !this.switchTheme,
                  {
                    color: this.getColor(index, true)
                  },
                  {}
                )
              };
            });
          })()
        },
        xAxis: {
          type: 'value',
          name: this.option.xAxisName,
          axisLine: {
            lineStyle: {
              color: this.option.lineColor || '#333'
            }
          },
          inverse: this.vaildData(this.option.xAxisInverse, false),
          show: this.vaildData(this.option.xAxisShow, true),
          splitLine: {
            show: this.vaildData(this.option.xAxisSplitLineShow, false)
          },
          axisLabel: {
            interval: this.option.xAxisinterval || 'auto',
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.nameColor || '#333',
              fontSize: this.option.xNameFontSize || 14
            }
          }
        },
        yAxis: {
          type: 'value',
          name: this.option.yAxisName,
          axisLabel: {
            textStyle: {
              color: this.option.nameColor || '#333',
              fontSize: this.option.yNameFontSize || 14
            },
            formatter: value => {
              const { yAxisShow, yValueFormatPath = [] } = this.option;
              if (yAxisShow && yValueFormatPath.length > 0) {
                return formatByPath(yValueFormatPath, value);
              } else {
                return value;
              }
            }
          },
          axisLine: {
            lineStyle: {
              color: this.option.lineColor || '#333'
            }
          },
          inverse: this.vaildData(this.option.yAxisInverse, false),
          show: this.vaildData(this.option.yAxisShow, true),
          splitLine: {
            show: this.vaildData(this.option.yAxisSplitLineShow, true)
          },
          scale: true
        },
        series: (() => {
          const list = (optionData.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: ele.type || 'scatter',
              // symbolSize: function(data) {
              //   return Math.sqrt(data[0]) / 5e2;
              // },
              symbolSize: 20,
              itemStyle: this.ishasprop(
                !this.switchTheme,
                {
                  color:
                    this.option.various == false
                      ? this.getColor(index)
                      : params => this.getColor(params.dataIndex)
                },
                {}
              )
            });
          });
          return list;
        })()
      };

      this.myChart.resize();
      this.myChart.setOption(option, true);

      this.chartClick();
    }
  }
};
</script>
